import { gql } from '@apollo/client';

export const CREATE_ACCESS_TOKEN_MUTATION = gql`
  mutation CreateAccessTokenMutation($name: String!) {
    createAccessToken(name: $name) {
      ... on CreateAccessTokenSuccess {
        accessToken {
          id
          name
          createdAt
          expiresAt
          lastUsedAt
          token
        }
      }
      ... on ValidationError {
        errors {
          error
          path
        }
      }
    }
  }
`;
